"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutContentCache = void 0;
const reversible_map_1 = require("../../../../util/reversible-map");
class LayoutContentCache {
    constructor() {
        // ContentItems currently do not have a unique id, this helps us to lookup items by value
        this.contentItemCache = new reversible_map_1.ReversibleMap();
        this.contentItemCacheId = 0;
        this.createCacheKey = () => {
            const key = `entity-${this.contentItemCacheId.toString()}`;
            this.contentItemCacheId += 1;
            return key;
        };
        this.hasKey = (id) => {
            return this.contentItemCache.hasKey(id);
        };
        this.getItemOrUndefined = (id) => {
            try {
                return this.getContentItemOrThrow(id);
            }
            catch (error) {
                return undefined;
            }
        };
        this.getContentItemOrThrow = (id, expectedType) => {
            if (!this.contentItemCache.hasKey(id)) {
                throw new Error('Layout component has been destroyed or detached from the current layout.');
            }
            const contentItem = this.contentItemCache.getValue(id);
            if (expectedType && !expectedType.includes(contentItem.type)) {
                throw new Error(`Layout item is not the expected type. Expected ${expectedType.join(', ')}, got ${contentItem.type}.`);
            }
            return contentItem;
        };
        this.getOrCreateEntityId = (contentItem) => {
            if (this.contentItemCache.hasValue(contentItem)) {
                return this.contentItemCache.getKey(contentItem);
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const onItemDestroyed = ({ origin, ...rest }) => {
                if (origin === contentItem) {
                    this.contentItemCache.deleteValue(contentItem);
                    contentItem.unbind('itemDestroyed', onItemDestroyed);
                }
            };
            contentItem.on('itemDestroyed', onItemDestroyed);
            const key = this.createCacheKey();
            this.contentItemCache.setUnique(key, contentItem);
            return key;
        };
    }
}
exports.LayoutContentCache = LayoutContentCache;
